import { createContext } from 'react';

import { UpdatePasswordModalContextProps } from './UpdatePasswordModalContext.types';

export const UpdatePasswordModalContext = createContext<UpdatePasswordModalContextProps | undefined>(undefined);
